/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Defect_Shelf_Err_MissingInputs */

const vi_defect_shelf_err_missing = /** @type {(inputs: Defect_Shelf_Err_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa cấu hình kệ hàng lỗi. Vào Vị trí kho để đánh dấu một kệ là kệ hàng lỗi.`)
};

/**

* @param {Defect_Shelf_Err_MissingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const defect_shelf_err_missing = /** @type {((inputs?: Defect_Shelf_Err_MissingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Defect_Shelf_Err_MissingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_defect_shelf_err_missing(inputs)
});